import { type LiterallyAnything } from '@/types/utils';

/**
 * @param key Object property name to sort by
 * @returns Array of objects sorted alphabetically by given property
 */
export const sortAlphabetically =
	(key: string) => (a: LiterallyAnything, b: LiterallyAnything) =>
		a[key].toLowerCase().localeCompare(b[key].toLowerCase());

/**
 * For sorting two level objects
 *
 * @param key Property name of object
 * @param subKey Property name of found object to sorty by
 * @returns Array of objects sorted alphabetically by given property
 */
export const sortAlphabeticallyBySubKey =
	(key: string, subKey: string) =>
	(a: LiterallyAnything, b: LiterallyAnything) =>
		a[key][subKey]
			.toLowerCase()
			.localeCompare(b[key][subKey].toLowerCase());
